import { render, staticRenderFns } from "./ModulesContentContainer.vue?vue&type=template&id=7e50c9b3&"
import script from "./ModulesContentContainer.vue?vue&type=script&lang=js&"
export * from "./ModulesContentContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CardsAccreditation: require('/opt/build/repo/components/Cards/Accreditation.vue').default})
